import { beginTask, endTask } from 'redux-nprogress';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { selectCurrent } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'nflSchedule';
export const selectNFLScheduleState = state => state[STORE_KEY];


// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  byeTeamsByWeek: [],
  currentSubview: null,
  matchups: [],
  formulaId: 1,
  year: null,
  week: null,
  currentWeek: 0,
  hasLoaded: false,
  error: null,
};

const nflScheduleReducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default nflScheduleReducer;


// ------------------------------------
// Actions
// ------------------------------------
export const LOAD_NFL_SCHEDULE_REQUEST = `${STORE_KEY}/LOAD_NFL_SCHEDULE_REQUEST`;
export const LOAD_NFL_SCHEDULE_SUCCESS = `${STORE_KEY}/LOAD_NFL_SCHEDULE_SUCCESS`;
export const LOAD_NFL_SCHEDULE_ERROR = `${STORE_KEY}/LOAD_NFL_SCHEDULE_ERROR`;

export const SET_NFL_SCHEDULE_SUBVIEW = `${STORE_KEY}/SET_NFL_SCHEDULE_SUBVIEW`;
export const SET_NFL_SCHEDULE_WEEK = `${STORE_KEY}/SET_NFL_SCHEDULE_WEEK`;

export const loadNFLScheduleGridRequest = ({ year, week, formulaId }) => ({
  type: LOAD_NFL_SCHEDULE_REQUEST,
  payload: { year, week, formulaId },
});
export const loadNFLScheduleGridSuccess = (matchups, byeTeamsByWeek) => ({
  type: LOAD_NFL_SCHEDULE_SUCCESS,
  payload: { matchups, byeTeamsByWeek },
});
export const loadNFLScheduleGridError = error => ({
  type: LOAD_NFL_SCHEDULE_ERROR,
  payload: { error },
});

export const setNFLScheduleGridSubview = subview => ({
  type: SET_NFL_SCHEDULE_SUBVIEW,
  payload: { subview },
});

export const setNFLScheduleWeek = currentWeek => ({
  type: SET_NFL_SCHEDULE_WEEK,
  payload: { currentWeek },
});


actions[LOAD_NFL_SCHEDULE_REQUEST] = (state, { payload: { year, week, formulaId } }) => ({
  ...state,
  year,
  week,
  formulaId,
  hasLoaded: false,
});

actions[LOAD_NFL_SCHEDULE_SUCCESS] = (state, { payload: { matchups, byeTeamsByWeek } }) => ({
  ...state,
  hasLoaded: true,
  matchups,
  byeTeamsByWeek,
});

actions[LOAD_NFL_SCHEDULE_ERROR] = (state, { payload }) => ({
  ...state,
  error: payload.error,
});

actions[SET_NFL_SCHEDULE_SUBVIEW] = (state, { payload }) => ({
  ...state,
  currentSubview: payload.subview,
});

actions[SET_NFL_SCHEDULE_WEEK] = (state, { payload }) => ({
  ...state,
  currentWeek: payload.currentWeek,
});

export const loadMatchups = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadNFLScheduleGridRequest({ year, week, formulaId }));

    // const position = 'QB';
    // const calcStart = 1;
    const calcEnd = year >= 2021 ? 18 : 17;
    // const showStart = 1;
    // const showEnd = year >= 2021 ? 18 : 17;
    const predictionsData = await api.projections.getPredictionsSeason({ year, formulaId });
    const { bye_teams: byeTeamsByWeek, matchups: matchupsRaw } = predictionsData;
    // const sos = await api.stats.getStrengthOfSchedule({
    //   position,
    //   formulaId,
    //   year,
    //   calcStart,
    //   calcEnd,
    //   showStart,
    //   showEnd,
    // });
    // const { strength_of_schedule: stats } = sos;
    const matchupsMap = matchupsRaw.filter(game => game.week < calcEnd + 1).reduce(
      (acc, game) => acc.set(game.week, [...acc.get(game.week) || [], game]),
      new Map());
    const matchups = [...matchupsMap.values()];
    dispatch(loadNFLScheduleGridSuccess(matchups, byeTeamsByWeek));
  } catch (error) {
    dispatch(loadNFLScheduleGridError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View / Route
// ------------------------------------
export const NFL_SCHEDULE_GRID_VIEW = `${STORE_KEY}/NFL_SCHEDULE_GRID_VIEW`;
viewNames[NFL_SCHEDULE_GRID_VIEW] = 'NFLSchedule';
routes[NFL_SCHEDULE_GRID_VIEW] = {
  path: '/nfl-schedule-grid',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { year } = selectQuery(state);
    const { season: currentYear } = selectCurrent(state, 'projections');
    if (year === null || year === undefined || year === 'null') year = currentYear;
    const weeks = 1;
    const formulaId = 1;
    dispatch(setNFLScheduleGridSubview('full-schedule'));
    // dispatch(setNFLScheduleWeek(1));
    await dispatch(loadMatchups(year, weeks, formulaId));
  },
};

export const NFL_SCHEDULE_GRID_SUBVIEW = 'NFLSchedule/VIEW_SUBVIEW';
viewNames[NFL_SCHEDULE_GRID_SUBVIEW] = 'NFLSchedule';
routes[NFL_SCHEDULE_GRID_SUBVIEW] = {
  path: '/nfl-schedule-grid/:subview',
  thunk: async (dispatch, getState) => {
    const state = getState();
    const { subview } = state.location.payload;
    const { season: currentYear } = selectCurrent(state, 'projections');
    const matchups = selectNFLScheduleState(state).matchups;
    if (!matchups || !matchups.length) {
      await dispatch(loadMatchups(currentYear, 1, 1));
    }
    dispatch(setNFLScheduleGridSubview(subview));
  },
};
// export const NFL_SCHEDULE_WEEK = 'NFLSchedule/VIEW_SUBVIEW';
// viewNames[NFL_SCHEDULE_WEEK] = 'NFLSchedule';
// routes[NFL_SCHEDULE_GRID_SUBVIEW] = {
//   path: '/nfl-schedule-grid/full-schedule',
//   thunk: async (dispatch, getState) => {
//     const state = getState();
//     const { currentWeek } = state.location.payload;
//     dispatch(setNFLScheduleGridSubview(subview));
//   },
// };

export const goScheduleGridSubview = ({ subview }) => ({
  type: NFL_SCHEDULE_GRID_SUBVIEW,
  payload: { subview },
});



// WEBPACK FOOTER //
// ./src/app/views/NFLSchedule/module/nflSchedule.js